// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SourcesIndexRouteImport } from './routes/sources/index'
import { Route as ReviewIndexRouteImport } from './routes/review/index'
import { Route as ReleasesIndexRouteImport } from './routes/releases/index'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index'
import { Route as DiscoveredAppsIndexRouteImport } from './routes/discovered-apps/index'
import { Route as AuditLogIndexRouteImport } from './routes/audit-log/index'
import { Route as AppsIndexRouteImport } from './routes/apps/index'
import { Route as SourcesSourceIdRouteImport } from './routes/sources/$sourceId'
import { Route as ReleasesReleaseIdRouteImport } from './routes/releases/$releaseId'
import { Route as JobsRunsRouteImport } from './routes/jobs/runs'
import { Route as JobsFailuresRouteImport } from './routes/jobs/failures'
import { Route as AppsAppIdRouteImport } from './routes/apps/$appId'
import { Route as AppsAppIdIndexRouteImport } from './routes/apps/$appId.index'
import { Route as AppsAppIdSourcesRouteImport } from './routes/apps/$appId.sources'
import { Route as AppsAppIdReleasesRouteImport } from './routes/apps/$appId.releases'
import { Route as AppsAppIdAliasesRouteImport } from './routes/apps/$appId.aliases'

const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SourcesIndexRoute = SourcesIndexRouteImport.update({
            id: '/sources/',path: '/sources/',getParentRoute: () => rootRouteImport
          })
const ReviewIndexRoute = ReviewIndexRouteImport.update({
            id: '/review/',path: '/review/',getParentRoute: () => rootRouteImport
          })
const ReleasesIndexRoute = ReleasesIndexRouteImport.update({
            id: '/releases/',path: '/releases/',getParentRoute: () => rootRouteImport
          })
const JobsIndexRoute = JobsIndexRouteImport.update({
            id: '/jobs/',path: '/jobs/',getParentRoute: () => rootRouteImport
          })
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
            id: '/feedback/',path: '/feedback/',getParentRoute: () => rootRouteImport
          })
const DiscoveredAppsIndexRoute = DiscoveredAppsIndexRouteImport.update({
            id: '/discovered-apps/',path: '/discovered-apps/',getParentRoute: () => rootRouteImport
          })
const AuditLogIndexRoute = AuditLogIndexRouteImport.update({
            id: '/audit-log/',path: '/audit-log/',getParentRoute: () => rootRouteImport
          })
const AppsIndexRoute = AppsIndexRouteImport.update({
            id: '/apps/',path: '/apps/',getParentRoute: () => rootRouteImport
          })
const SourcesSourceIdRoute = SourcesSourceIdRouteImport.update({
            id: '/sources/$sourceId',path: '/sources/$sourceId',getParentRoute: () => rootRouteImport
          })
const ReleasesReleaseIdRoute = ReleasesReleaseIdRouteImport.update({
            id: '/releases/$releaseId',path: '/releases/$releaseId',getParentRoute: () => rootRouteImport
          })
const JobsRunsRoute = JobsRunsRouteImport.update({
            id: '/jobs/runs',path: '/jobs/runs',getParentRoute: () => rootRouteImport
          })
const JobsFailuresRoute = JobsFailuresRouteImport.update({
            id: '/jobs/failures',path: '/jobs/failures',getParentRoute: () => rootRouteImport
          })
const AppsAppIdRoute = AppsAppIdRouteImport.update({
            id: '/apps/$appId',path: '/apps/$appId',getParentRoute: () => rootRouteImport
          })
const AppsAppIdIndexRoute = AppsAppIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppsAppIdRoute
          })
const AppsAppIdSourcesRoute = AppsAppIdSourcesRouteImport.update({
            id: '/sources',path: '/sources',getParentRoute: () => AppsAppIdRoute
          })
const AppsAppIdReleasesRoute = AppsAppIdReleasesRouteImport.update({
            id: '/releases',path: '/releases',getParentRoute: () => AppsAppIdRoute
          })
const AppsAppIdAliasesRoute = AppsAppIdAliasesRouteImport.update({
            id: '/aliases',path: '/aliases',getParentRoute: () => AppsAppIdRoute
          })





const AppsAppIdRouteChildren = {
  AppsAppIdAliasesRoute: AppsAppIdAliasesRoute,AppsAppIdReleasesRoute: AppsAppIdReleasesRoute,AppsAppIdSourcesRoute: AppsAppIdSourcesRoute,AppsAppIdIndexRoute: AppsAppIdIndexRoute
}

const AppsAppIdRouteWithChildren = AppsAppIdRoute._addFileChildren(AppsAppIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LoginRoute: LoginRoute,AppsAppIdRoute: AppsAppIdRouteWithChildren,JobsFailuresRoute: JobsFailuresRoute,JobsRunsRoute: JobsRunsRoute,ReleasesReleaseIdRoute: ReleasesReleaseIdRoute,SourcesSourceIdRoute: SourcesSourceIdRoute,AppsIndexRoute: AppsIndexRoute,AuditLogIndexRoute: AuditLogIndexRoute,DiscoveredAppsIndexRoute: DiscoveredAppsIndexRoute,FeedbackIndexRoute: FeedbackIndexRoute,JobsIndexRoute: JobsIndexRoute,ReleasesIndexRoute: ReleasesIndexRoute,ReviewIndexRoute: ReviewIndexRoute,SourcesIndexRoute: SourcesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)